import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'price-amount',
  templateUrl: './price-amount.component.html',
  styleUrls: ['./price-amount.component.scss']
})
export class PriceAmountComponent implements OnInit {
  @Input() rewardNight: boolean;
  @Input() freeNight: boolean;
  @Input() amount: number;
  @Input() currencyCode: string;
  @Input() messages: number;
  @Input() seleniumName: string;

  showCurrency: boolean;
  showAmount: boolean;
  showFree: boolean;
  showPoints: boolean;

  constructor() {}

  ngOnInit() {
    this.showAmount = !this.rewardNight && !this.freeNight && (!!this.amount || this.amount === 0);
    this.showCurrency = this.showAmount && !!this.currencyCode;
    this.showPoints = this.rewardNight && !this.freeNight;
    this.showFree = !this.rewardNight && this.freeNight;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/price-amount/price-amount.component.ts